import React, { useState } from "react";
import "../Gallery/Gallery.css";
import { gsap } from "gsap";
const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null); // Store the selected image source

  const images = [
    { src: "g1.webp", alt: "Gallery Image 1" },
    { src: "g2.webp", alt: "Gallery Image 2" },
    { src: "g3.webp", alt: "Gallery Image 3" },
    { src: "g4.webp", alt: "Gallery Image 4" },
    { src: "g5.webp", alt: "Gallery Image 5" },
    { src: "g6.webp", alt: "Gallery Image 6" },
  ];

  const handleMouseMove = (e, card) => {
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = ((y - centerY) / centerY) * 20;
    const rotateY = ((centerX - x) / centerX) * 20;

    gsap.to(card, {
      duration: 0,
      rotationX: rotateX,
      rotationY: rotateY,
      transformPerspective: 1500,
      ease: "power3.out",
    });
  };

  const handleMouseLeave = (card) => {
    gsap.to(card, {
      duration: 0,
      rotationX: 0,
      rotationY: 0,
      ease: "power3.out",
    });
  };

  // Handle the click event to open the image in full-screen overlay
  const handleImageClick = (src) => {
    setSelectedImage(src); // Set the selected image as the one clicked
  };

  // Close the overlay
  const closeOverlay = () => {
    setSelectedImage(null); // Reset the selected image to close the overlay
  };

  return (
    <>
      <div className="full-gallery">
        <h1 className="main-head-hn">OUR Gallery</h1>
        <div className="gallery-container">
          {images.map((image, index) => (
            <div
              key={index}
              className="cardd"
              onMouseMove={(e) => handleMouseMove(e, e.currentTarget)}
              onMouseLeave={(e) => handleMouseLeave(e.currentTarget)}
              onClick={() => handleImageClick(image.src)} // Open image on click
            >
              <img src={image.src} alt={image.alt} />
              <div className="overlayy">
                <p>Click to view full image</p>
              </div>
            </div>
          ))}
        </div>

        {/* Image Overlay - This shows the selected image in full screen */}
        {selectedImage && (
          <div className="image-overlay" onClick={closeOverlay}>
            <img src={selectedImage} alt="Selected" className="full-image" />
            <span className="close-btn" onClick={closeOverlay}>
              X
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default Gallery;
